import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { useVerificationEmail } from '@/Domain/hooks/Auth/useVerificationEmail.hook';

const formatCountdown = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

const EmailVerificationPage = () => {
  const { t } = useTranslation(['email_verification', 'ERRORS']);

  const {
    userEmail,
    handleResendClick,
    isPending,
    showResendMessage,
    apiError,
    cooldownSecondsRemaining,
  } = useVerificationEmail();

  const isCoolingDown = cooldownSecondsRemaining > 0;

  return (
    <div className="text-center text-foreground">
      <h1 className="mb-8 text-center text-xl font-semibold text-foreground">{t('title')}</h1>
      <p className="text-muted-foreground" data-testid="email-verification-description">
        {userEmail ? (
          <Trans
            i18nKey="email_verification:link.send_to"
            values={{ email: userEmail }}
            components={{
              // ph-no-capture keeps the address out of PostHog autocapture and session replays.
              email: <strong className="ph-no-capture break-words font-medium text-foreground" />,
            }}
          />
        ) : (
          t('link.send')
        )}
      </p>
      <Button
        variant="dark"
        className="w-full mt-5 tabular-nums"
        onClick={handleResendClick}
        loading={isPending}
        disabled={isCoolingDown}
      >
        {isCoolingDown
          ? `${t('button.resend')} (${formatCountdown(cooldownSecondsRemaining)})`
          : t('button.resend')}
      </Button>
      {showResendMessage && <p className="mt-2 text-base text-foreground">{t('link.reset')}</p>}
      {apiError != null && (
        <p className="mt-1 text-base text-destructive">{t(`ERRORS:${apiError}`)}</p>
      )}
    </div>
  );
};

export default EmailVerificationPage;
